import {Song} from "../../../store/api/types";

export function convertSecondsToTime(duration: number | undefined): string {
    if (duration === undefined) {
        return '0:00';
    }

    // Round the duration to avoid floating-point precision issues
    duration = Math.round(duration);

    const hours = Math.floor(duration / 3600);
    const minutes = Math.floor((duration % 3600) / 60);
    const seconds = duration % 60;

    // Format each part with leading zeroes if necessary
    const hoursStr = hours > 0 ? `${hours}:` : '';
    const minutesStr = minutes < 10 ? `${hours > 0 ? '0' : ''}${minutes}` : `${minutes}`;
    const secondsStr = seconds < 10 ? `0${seconds}` : `${seconds}`;

    return `${hoursStr}${minutesStr}:${secondsStr}`;
}

export function shuffleTracks(tracks: Song[]) {
    const result = [...tracks];
    for (let i = 0; i < result.length; i++) {
        const randomIndex = Math.floor(Math.random() * (i + 1));
        const savedItem = result[i];
        result[i] = result[randomIndex];
        result[randomIndex] = savedItem;
    }
    return result;
}
